import { Box, Stack, Grid, Paper, Avatar, Container, Tab, Tabs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';



import noMill from "@react-jvectormap/norway/dist/noMill.json";
import caMill from "@react-jvectormap/canada/dist/caMill.json";
import usMill from "@react-jvectormap/unitedstates/dist/usMill.json";
import { VectorMap } from "@react-jvectormap/core";
import { styled } from '@mui/material/styles';
import { borderRight } from "@mui/system";
import React from "react";


const Map = () => {
  const navigate = useNavigate();
  const mapHandler = (event, code) => {
    const selectedState = code.split("-");
    //console.log(selectedState[1]);
    navigate("/district", {
      replace: true,
      state: { filter: selectedState[1] },
    });
  };

  const norwayMapHandler = (event, code) => {
    const selectedState = code.split("-");
    console.log(code);
    navigate("/district", {
      replace: true,
      state: { filter: selectedState[0] },
    });
  };

  const canadaMapHandler = (event, code) => {
    const selectedState = code.split("-");
    console.log(code);
    navigate("/district", {
      replace: true,
      state: { filter: selectedState[1] },
    });
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#fff' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: "#fff",
  }));

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (


    <div className="App">
      <h1>Lodge Map</h1>
      <Container fixed>
        <div style={{ maxWidth: "100%", paddingTop: "12px" }}>
          <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                <Tab label="USA" {...a11yProps(0)} />
                <Tab label="Norway" {...a11yProps(1)} />
                <Tab label="Canada" {...a11yProps(2)} />
              </Tabs>
            </Box>
            {/* UNITED STATES */}
            <TabPanel value={value} index={0}>
              <Paper >
                <VectorMap
                  map={usMill}
                  backgroundColor="#fff"
                  focusOn={{ scale: 6, lat: 56, lng: 120 }}
                  zoomMin={"8"}
                  zoomMax={"8"}
                  panOnDrag={true}
                  zoomOnScroll={false}
                  zoomButtons={false}
                  regionsSelectable={true}
                  regionsSelectableOne={false}
                  style={{ height: "60vh" }}
                  onRegionTipShow={(e, c) => {
                    e.preventDefault();
                  }}
                  series={{
                    regions: [{
                      values: {
                        'US-HI': '#172749',
                        'US-AK': '#92C5CB',
                        'US-WA': '#92C5CB',
                        'US-OR': '#92C5CB',
                        'US-ID': '#92C5CB',
                        'US-WY': '#92C5CB',
                        'US-MI': '#92C5CB',
                        'US-WI': '#92C5CB',
                        'US-IL': '#92C5CB',
                        'US-KY': '#92C5CB',
                        'US-TN': '#92C5CB',
                        'US-MS': '#92C5CB',
                        'US-AL': '#92C5CB',
                        'US-IN': '#92C5CB',
                        'US-OH': '#92C5CB',
                        'US-MT': '#172749',
                        'US-CA': '#172749',
                        'US-ND': '#172749',
                        'US-NV': '#172749',
                        'US-UT': '#172749',
                        'US-AZ': '#172749',
                        'US-NM': '#172749',
                        'US-CO': '#172749',
                        'US-ME': '#172749',
                        'US-NH': '#172749',
                        'US-NY': '#172749',
                        'US-PA': '#172749',
                        'US-CT': '#172749',
                        'US-VA': '#172749',
                        'US-VT': '#172749',
                        'US-MA': '#172749',
                        'US-NJ': '#172749',
                        'US-WV': '#172749',
                        'US-MD': '#172749',
                        'US-NC': '#172749',
                        'US-SC': '#172749',
                        'US-GA': '#172749',
                        'US-FL': '#172749',
                        'US-MN': '#3983A8',
                        'US-TX': '#3983A8',
                        'US-IA': '#3983A8',
                        'US-MO': '#3983A8',
                        'US-AR': '#3983A8',
                        'US-LA': '#3983A8',
                        'US-OK': '#3983A8',
                        'US-KS': '#3983A8',
                        'US-SD': '#3983A8',
                        'US-NE': '#3983A8'





                      },
                      attribute: 'fill'
                    }]
                  }}

                  regionStyle={{
                    initial: {
                      fill: "#ddd",
                      "fill-opacity": 1,
                      stroke: "#444444",
                      "stroke-width": 1,
                      "stroke-opacity": 0.7,
                    },
                  }}
                  onRegionClick={mapHandler}
                />
              </Paper>
            </TabPanel>
            {/* NORWAY */}
            <TabPanel value={value} index={1}>
              <Paper>
                <VectorMap
                  map={noMill}
                  backgroundColor="#fff"
                  focusOn={{ scale: 6, lat: 65, lng: 16 }}
                  containerClassName="map"
                  regionStyle={{
                    initial: {
                      fill: "#3983A8",
                      "fill-opacity": 1,
                      stroke: "none",
                      "stroke-width": 1,
                      "stroke-opacity": 0.7,
                    },
                    hover: {},
                    selected: {},
                    selectedHover: {}
                  }}
                  zoomMin={"7"}
                  zoomMax={"7"}
                  panOnDrag={false}
                  zoomButtons={false}
                  regionsSelectable={false}
                  regionsSelectableOne={false}
                  zoomOnScroll={false}
                  style={{ height: "60vh" }}
                  onRegionTipShow={(e, c) => {
                    e.preventDefault();
                  }}
                  onRegionClick={norwayMapHandler}
                />
              </Paper>
            </TabPanel>
            {/* CANADA */}
            <TabPanel value={value} index={2}>
              <Paper >
                <VectorMap
                  map={caMill}
                  backgroundColor="#fff"
                  focusOn={{ scale: 8, lat: 56, lng: 120 }}
                  zoomMin={"8"}
                  zoomMax={"8"}
                  panOnDrag={false}
                  zoomButtons={false}
                  zoomOnScroll={false}
                  regionsSelectable={false}
                  regionsSelectableOne={false}
                  style={{ height: "60vh" }}
                  onRegionTipShow={(e, c) => {
                    e.preventDefault();
                  }}

                  series={{
                    regions: [{
                      values: {
                        'CA-BC': '#3983A8',
                        'CA-AB': '#172749',
                        'CA-SK': '#172749'
                      },
                      attribute: 'fill'
                    }]
                  }}

                  regionStyle={{
                    initial: {
                      fill: "#ddd",
                      "fill-opacity": 1,
                      stroke: "#444444",
                      "stroke-width": 1,
                      "stroke-opacity": 0.7,
                    },
                  }}
                  onRegionClick={canadaMapHandler}
                />
              </Paper>
            </TabPanel>

          </div>
        </div>
      </Container>

    </div>
  );
};

export default Map;
